define([
	"dojo/_base/declare",
	"csi/heading/AttributeAction",
], function(declare, AttributeAction) {

	return declare(AttributeAction, {
		/**
		 * @override
		 * Return true if there is a store for the attribute
		 * NOTE: aggregate stores will not yet work for other attribute types, such as type="string" and format="Selection"
		 */
		checkNodeAccess(node) {
			const {heading: {classRenderer, m_relationship}, m_viewRef} = this;
			return m_viewRef || m_relationship || classRenderer && this.inherited(arguments);
		}
	});
});